// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "RedemptionsModuleRowMobile__textCenter__CYzO-";
export const redemptionsModuleRowMobile = "RedemptionsModuleRowMobile__redemptionsModuleRowMobile__LM7lX";
export const amount = "RedemptionsModuleRowMobile__amount__guXYx font-faces__sansLight__-1Yzy font-faces__sans__uCf65";